import { createLogger } from './bf-lp1-logger.js';

let BACKEND_URL = 'https://backend.alia-cloudflare.com';

// Create logger
const logger = createLogger(false, 'Quiz', 'info');

// Track preloaded assets
const preloadedAssets = new Set();

// Quiz data
const quizData = {
  "questions": [
    {
      "id": "person",
      "text": "Who is this for?",
      "options": [
        {
          "value": "me",
          "text": "Me",
          "shopify_answer": "Me"
        },
        {
          "value": "child",
          "text": "My Child (0-12)",
          "shopify_answer": "My Loved One"
        },
        {
          "value": "teen",
          "text": "My Tween/Teen (12+)",
          "shopify_answer": "My Tween-Teen"
        }
      ]
    },
    {
      "id": "skin_condition",
      "text": "What is your skin condition?",
      "options": [
        {
          "value": "eczema",
          "text": '😣 <span class="font-semibold">Eczema-prone</span> – Dry, itchy, irritated & red',
          "shopify_answer": "Eczema"
        },
        {
          "value": "psoriasis",
          "text": '😣 <span class="font-semibold">Psoriasis-prone</span> – Dry, scaly, red & itchy',
          "shopify_answer": "Psoriasis"
        },
        {
          "value": "rosacea",
          "text": '😣 <span class="font-semibold">Rosacea-prone</span> – Facial redness & sensitivity',
          "shopify_answer": "Rosacea"
        },
        {
          "value": "acne",
          "text": '😣 <span class="font-semibold">Breakout-prone</span> – Blemishes, acne & congestion',
          "shopify_answer": "Acne"
        },
        {
          "value": "not_sure",
          "text": '🤔 <span class="font-semibold">Not sure or other concerns?</span>',
          "shopify_answer": "Other"
        }
      ]
    }
  ],
  "sections": {
    "me": {
      "eczema": ["header", "solution", "lt_30d", "before-after", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "psoriasis": ["header", "solution", "lt_30d", "before-after", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "rosacea": ["header", "solution", "lt_30d", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "acne": ["header", "solution", "lt_30d", "before-after", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "not_sure": ["header", "solution", "old-vs-new", "lt_30d", "reviews", "founders-video", "faqs--after", "harming", "footer"]
    },
    "child": {
      "eczema": ["header", "solution", "lt_30d", "before-after",  "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "psoriasis": ["header", "solution", "lt_30d", "before-after",  "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "rosacea": ["header", "solution", "lt_30d", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "acne": ["header", "solution", "lt_30d", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "not_sure": ["header", "solution", "old-vs-new", "lt_30d", "reviews", "founders-video", "faqs--after", "harming", "footer"]
    },
    "teen": {
      "eczema": ["header", "solution", "old-vs-new", "lt_30d", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "psoriasis": ["header", "solution", "old-vs-new", "lt_30d", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "rosacea": ["header", "solution", "lt_30d", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "acne": ["header", "solution",  "lt_30d", "before-after",  "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"],
      "not_sure": ["header", "solution", "old-vs-new", "lt_30d", "reviews", "reveal", "founders-video", "faqs--after", "harming", "footer"]
    }
  },
  "recommendations": {
    "me": {
      "eczema": {
        "skin-health-rescue-set": "Skin Health - Rescue Set (SRL, MSS)",
        "skin-rescue-lotion": "Skin Rescue Lotion"
      },
      "psoriasis": {
        "skin-health-rescue-set": "Skin Health - Rescue Set (SRL, MSS)",
        "manuka-skin-saver": "Manuka Skin Saver"
      },
      "rosacea": {
        "skin-health-face-set": "Skin Health - Face Set (SRL, RLR)",
        "skin-rescue-lotion": "Skin Rescue Lotion"
      },
      "acne": {
        "blemish-ban-kit": "Blemish Ban Kit (BBG, BBT, BCR)",
        "breakout-rescue-set-intensive": "Breakout Rescue Set - Intensive (BBG, BBT, MSS, BCR)",
        "breakout-care-set-gentle": "Breakout Care Set - Gentle (BBG, BBT, SRL, BCR)"
      },
      "not_sure": {
        "dry-dehydrated-skin-health-set": "Dry, Dehydrated Skin Health Set (SRL, MSS, RLR)",
        "holistic-skin-health-set": "Holistic Skin Health Set (SRL, MSS, SHS, RLR, BCR)",
        "facial-skin-health-set": "Facial Skin Health Set (SRL, RLR)",
        "breakout-rescue-set-intensive": "Breakout Rescue Set - Intensive (BBT, BBG, MSS, BCR)",
        "oncology-skin-health-set": "Oncology Skin Health Set (MSSx2, SRL, RLR, Pouch)"
      }
    },
    "child": {
      "eczema": {
        "baby-toddler-skin-health-set": "Baby & Toddler Skin Health Set (SRL, SHS, RLR)",
        "baby-to-granny-set": "Baby to Granny Set (SRL, SHS)",
        "kids-problem-solver-set": "Kids Problem Solver Set (SRL, SHS, KMSSYR x2, RLR)"
      },
      "psoriasis": {
        "baby-toddler-skin-health-set": "Baby & Toddler Skin Health Set (SRL, SHS, RLR)",
        "baby-to-granny-set": "Baby to Granny Set (SRL, SHS)",
        "kids-problem-solver-set": "Kids Problem Solver Set (SRL, SHS, KMSSYR, RLR)"
      },
      "rosacea": {
        "skin-health-face-set": "Skin Health - Face Set (SRL, RLR)",
        "skin-rescue-lotion": "Skin Rescue Lotion"
      },
      "acne": {
        "manuka-skin-saver": "Under 12, we don't recommend our Blemish Ban range. If they are 2+ and their skin is struggling with breakouts our Manuka Skin Saver is the recommendation"
      },
      "not_sure": {
        "baby-toddler-skin-health-set": "Baby & Toddler Skin Health Set (SRL, SHS, RLR)",
        "baby-to-granny-set": "Baby to Granny Set (SRL, SHS)",
        "kids-problem-solver-set": "Kids Problem Solver Set (SRL, SHS, KMSSYR x2, RLR)",
        "holistic-skin-health-set": "Holistic Skin Health Set (SRL, MSS, SHS, RLR, BCR)"
      }
    },
    "teen": {
      "eczema": {
        "baby-to-granny-set": "Baby to Granny Set",
        "skin-health-rescue-set": "Skin Health - Rescue Set (SRL, MSS)",
        "kids-problem-solver-set": "Kids Problem Solver Set"
      },
      "psoriasis": {
        "skin-health-rescue-set": "Skin Health - Rescue Set",
        "manuka-skin-saver": "Manuka Skin Saver"
      },
      "rosacea": {
        "skin-health-face-set": "Skin Health - Face Set (SRL, RLR)",
        "skin-rescue-lotion": "Skin Rescue Lotion"
      },
      "acne": {
        "blemish-ban-kit": "Blemish Ban Kit (BBG, BBT, BCR)",
        "breakout-rescue-set-intensive": "Breakout Rescue Set - Intensive (BBG, BBT, MSS, BCR)",
        "breakout-care-set-gentle": "Breakout Care Set - Gentle (BBG, BBT, SRL, BCR)"
      },
      "not_sure": {
        "holistic-skin-health-set": "Holistic Skin Health Set (SRL, MSS, SHS, RLR, BCR)",
        "baby-to-granny-set": "Baby to Granny Set",
        "kids-problem-solver-set": "Kids Problem Solver Set",
        "breakout-rescue-set-intensive": "Breakout Rescue Set - Intensive"
      }
    }
  }
};

// Store quiz answers
const quizResults = {};

// Store prepared sections
let preparedSections = {};
let sectionsReady = false;

// Function to preload assets from HTML content
function preloadAssets(htmlContent) {
  const tempContainer = document.createElement('div');
  tempContainer.innerHTML = htmlContent;
  
  // Preload images
  const images = tempContainer.querySelectorAll('img');
  images.forEach(img => {
    const src = img.src || img.getAttribute('data-src');
    if (src && !preloadedAssets.has(src)) {
      const preloadImage = new Image();
      preloadImage.src = src;
      preloadedAssets.add(src);
      logger.debug('Preloading image:', src);
    }
  });
  
  // Preload videos
  const videos = tempContainer.querySelectorAll('video');
  videos.forEach(video => {
    const src = video.src || video.querySelector('source')?.src;
    if (src && !preloadedAssets.has(src)) {
      const preloadVideo = document.createElement('video');
      preloadVideo.src = src;
      preloadedAssets.add(src);
      logger.debug('Preloading video:', src);
    }
  });
}

// Fetch and prepare sections in advance
async function prepareSections() {
  try {
    logger.info('Preparing sections...');
    const pages = [
      '/pages/terms-conditions?view=lp1',
      '/pages/terms-conditions?view=lp1-solutions',
      '/pages/terms-conditions?view=lp1-me',
      '/pages/terms-conditions?view=lp1-child',
      '/pages/terms-conditions?view=lp1-teen'
    ];
    
    // Use Promise.all to load all pages in parallel
    const pagePromises = pages.map(async page => {
      const response = await fetch(page);
      const html = await response.text();
      
      // Create a temporary container to parse the HTML
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = html;
      
      // Get all sections
      const sections = tempContainer.querySelectorAll('.shopify-section [data-show-for]');
      logger.debug(`Found sections for ${page}:`, sections.length);
      
      // Group sections by their data-show-for attribute
      sections.forEach(section => {
        const showFor = section.getAttribute('data-show-for');
        if (showFor) {
          if (!preparedSections[showFor]) {
            preparedSections[showFor] = [];
          }
          const sectionHtml = section.outerHTML;
          preparedSections[showFor].push(sectionHtml);
          
          // Start preloading assets in the background
          setTimeout(() => preloadAssets(sectionHtml), 0);
          
          logger.debug(`Added section for ${showFor}`);
          logger.debug(`Total sections for ${showFor}:`, preparedSections[showFor].length);
        }
      });
    });
    
    // Wait for all pages to load
    await Promise.all(pagePromises);
    
    sectionsReady = true;
    logger.success('Sections prepared:', Object.keys(preparedSections));
    logger.debug('Preloaded assets:', Array.from(preloadedAssets));
    
    // Enable quiz buttons and remove loading state
    document.querySelectorAll('[data-trigger-quiz]').forEach(button => {
      button.disabled = false;
      button.classList.remove('opacity-50', 'cursor-not-allowed');
      button.classList.add('cursor-pointer');
    });
    
  } catch (error) {
    logger.error('Error preparing sections:', error);
    // Show error state on buttons
    document.querySelectorAll('[data-trigger-quiz]').forEach(button => {
      button.textContent = 'Error loading quiz. Please refresh the page.';
      button.classList.add('text-red-500');
    });
  }
}

// Generate questions from the JSON data
function generateQuestions() {
  logger.info('Generating questions...');
  const quizContainer = document.getElementById('quiz-container');
  quizContainer.innerHTML = ''; // Clear any existing content
  
  // Generate each question
  quizData.questions.forEach((question, index) => {
    const questionDiv = document.createElement('div');
    questionDiv.id = question.id;
    questionDiv.className = 'question-container w-full max-w-xl absolute';
    
    // Make the first question active
    if (index === 0) {
      questionDiv.classList.add('active');
    }
    
    // Create question content
    const questionContent = `
      <div class="bg-white rounded-lg shadow-lg py-8 px-4 w-[96%] sm:w-auto sm:px-8 mx-auto">
        <h2 class="text-2xl font-bold mb-6 pt-4 text-center">${question.text}</h2>
        <div class="space-y-3 sm:space-y-4 pb-4 options-container">
          ${question.options.map(option => `
            <button class="w-full bg-white border-2 border-gray-300 hover:border-gray-500 text-gray-800 text-xs sm:text-base font-semibold px-2 py-4 sm:px-6 rounded-lg text-left transition-all active:scale-[0.98]" 
                    data-question="${question.id}" 
                    data-value="${option.value}">
              ${option.text}
            </button>
          `).join('')}
        </div>
      </div>
    `;
    
    questionDiv.innerHTML = questionContent;
    quizContainer.appendChild(questionDiv);
  });
  
  // Add event listeners to all option buttons
  document.querySelectorAll('[data-question]').forEach(button => {
    button.addEventListener('click', handleOptionClick);
  });
  logger.success('Questions generated');
}

// Handle option click
function handleOptionClick() {
  const questionId = this.getAttribute('data-question');
  const value = this.getAttribute('data-value');
  
  logger.info('Option selected:', { questionId, value });
  
  // Store the selected value
  quizResults[questionId] = value;
  
  // Get the current question container
  const currentQuestion = document.getElementById(questionId);
  
  // Find the next question or show results
  const questionIds = quizData.questions.map(q => q.id);
  const currentIndex = questionIds.indexOf(questionId);
  
  if (currentIndex < questionIds.length - 1) {
    // First question - slide to the left
    currentQuestion.classList.add('exit-left');
    currentQuestion.classList.remove('active');
    
    // Show the next question
    const nextQuestionId = questionIds[currentIndex + 1];
    const nextQuestion = document.getElementById(nextQuestionId);
    
    setTimeout(() => {
      nextQuestion.classList.add('active');
    }, 300);
  } else {
    // Second question - just fade out in place
    currentQuestion.classList.add('fade-out');
    currentQuestion.classList.remove('active');
    
    // Check if sections are ready or if we're forcing the loader
    const urlParams = new URLSearchParams(window.location.search);
    const forceLoader = urlParams.get('show_loader') === 'true';

    logger.error('Force loader:', forceLoader);
    
    if (!sectionsReady || forceLoader) {
      // Show loading state
      const loadingState = document.createElement('div');
      loadingState.className = 'loading-state absolute inset-0 bg-[#B0E3BB]';
      loadingState.innerHTML = `
        <div class="flex flex-col gap-4 items-center justify-center h-full">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"></div>
          <p class="text-lg font-medium">Preparing your results...</p>
        </div>
      `;
      currentQuestion.parentNode.appendChild(loadingState);
      
      // If we're forcing the loader, don't wait for sections
      if (forceLoader) {
        // Simulate a delay
        setTimeout(() => {
          loadingState.remove();
          prepareResults();
          fadeOutDialog();
        }, 2000); // 2 second delay for testing
      } else {
        // Wait for sections to be ready
        const checkSections = setInterval(() => {
          if (sectionsReady) {
            clearInterval(checkSections);
            loadingState.remove();
            prepareResults();
            fadeOutDialog();
          }
        }, 100);
      }
    } else {
      // Prepare results and show them immediately
      prepareResults();
      fadeOutDialog();
    }
  }
}

function sendToKlaviyo(person, skinCondition) {
  try {
  const logger = createLogger(false, 'Klaviyo', 'debug');
  logger.info('Sending to Klaviyo', { person, skinCondition });

  const klaviyoForm = document.querySelector('.klaviyo-form form');
  if (klaviyoForm) {
    // Simulate user interaction with the "Who" input
    const whoInput = klaviyoForm.querySelector(`input[id*='Who']`); 
    if (whoInput) {
      // Focus the input
      whoInput.focus();
      // Simulate typing
      whoInput.value = person;
      // Trigger input events
      whoInput.dispatchEvent(new Event('input', { bubbles: true }));
      whoInput.dispatchEvent(new Event('change', { bubbles: true }));
      // Blur the input
      whoInput.blur();
      logger.debug('Set Who input:', person);
    }

    // Simulate user interaction with the "What" input
    const whatInput = klaviyoForm.querySelector(`input[id*='What']`);
    if (whatInput) {
      // Focus the input
      whatInput.focus();
      // Simulate typing
      whatInput.value = skinCondition;
      // Trigger input events
      whatInput.dispatchEvent(new Event('input', { bubbles: true }));
      whatInput.dispatchEvent(new Event('change', { bubbles: true }));
      // Blur the input
      whatInput.blur();
      logger.debug('Set What input:', skinCondition);
    }

    // Wait a moment for any animations or validation to complete
    setTimeout(() => {
      // Find and click the submit button
      const submitButton = klaviyoForm.querySelector('button');
      if (submitButton) {
        // Simulate mouse events
        submitButton.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
        submitButton.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
        submitButton.click();
        submitButton.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
        logger.success('Klaviyo submission attempted');
        }
      }, 500);
    }
  } catch (error) {
    logger.error('Error submitting to Klaviyo:', error);
  }
}

// Prepare results before showing them
function prepareResults() {
  logger.info('Preparing results...');
  // Get the recommendations
  const person = quizResults.person;
  const skinCondition = quizResults.skin_condition;
  const recommendations = quizData.recommendations[person][skinCondition];
  
  logger.debug('Quiz results:', { person, skinCondition, recommendations });

  sendToKlaviyo(person, skinCondition);
  
  // Handle section visibility based on quiz results
  handleSectionVisibility(person, skinCondition);
  logger.success('Results prepared and displayed');
}

function showBasicRecommendations(sectionsContainer) {
  logger.info('Showing basic recommendations...');
  
  const person = quizResults.person;
  const skinCondition = quizResults.skin_condition;
  const recommendations = quizData.recommendations[person][skinCondition];
  
  logger.debug('Quiz results:', { person, skinCondition, recommendations });
  
  // Use the prepared default results section
  if (preparedSections['default-results'] && preparedSections['default-results'].length > 0) {
    // Create a temporary container to parse and modify the HTML
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = preparedSections['default-results'][0];
    
    // Find the main-results element within the section
    const mainResults = tempContainer.querySelector('#main-recommendations-list');
    if (mainResults) {
      // Clear the container
      mainResults.innerHTML = '';
      
      // Add a summary of the selections
      const summary = document.createElement('div');
      summary.className = 'p-4 bg-green-50 rounded-lg border border-green-200 mb-6';
      
      const personText = quizData.questions[0].options.find(opt => opt.value === person).text;
      const conditionText = quizData.questions[1].options.find(opt => opt.value === skinCondition).text;
      
      summary.innerHTML = `
        <p class="font-semibold mb-2">Your Selections:</p>
        <p>Who is this for: <span class="font-medium">${personText}</span></p>
        <p>Skin condition: <span class="font-medium">${conditionText}</span></p>
      `;
      mainResults.appendChild(summary);
      
      // Add the recommendations
      const recommendationsTitle = document.createElement('div');
      recommendationsTitle.className = 'font-semibold mb-3 text-lg';
      recommendationsTitle.textContent = 'Recommended Products:';
      mainResults.appendChild(recommendationsTitle);
      
      if (typeof recommendations === 'object' && !Array.isArray(recommendations)) {
        // Handle object structure (new format)
        Object.entries(recommendations).forEach(([handle, description]) => {
          const item = document.createElement('div');
          item.className = 'p-4 bg-white rounded-lg border border-gray-200 shadow-sm';
          item.innerHTML = `
            <a href="/products/${handle}" class="block hover:text-green-600 transition-colors">
              ${description}
            </a>
          `;
          mainResults.appendChild(item);
        });
      } else if (typeof recommendations === 'string') {
        // Handle string case (like the special case for children with acne)
        const item = document.createElement('div');
        item.className = 'p-4 bg-white rounded-lg border border-gray-200 shadow-sm';
        item.textContent = recommendations;
        mainResults.appendChild(item);
      }

      logger.debug('Modified section:', tempContainer.innerHTML);
      
      // Add the modified section to the container
      sectionsContainer.insertAdjacentHTML('beforeend', tempContainer.innerHTML);
    } else {
      logger.error('Main results element not found in default results section');
    }
  } else {
    logger.error('Default results section not found in prepared sections');
  }
}

// Handle section visibility based on quiz results
function handleSectionVisibility(person, skinCondition) {
  logger.info('Handling section visibility...');

  // hide all .shopify-section elements
  logger.debug('Hiding all shopify-section elements');
  document.querySelectorAll('.shopify-section').forEach(section => {
    section.classList.add('hidden');
  });

  // Scroll to top of page
  window.scrollTo({ top: 0, behavior: 'instant' });

  // Hide all intro sections
  const introSections = document.querySelectorAll('.intro-section');
  introSections.forEach(section => {
    const parent = section.closest('.shopify-section');
    if (parent) {
      parent.classList.add('hidden');
    }
  });

  // Get the key for the prepared sections
  const sectionKey = `${person}--${skinCondition}`;
  logger.debug('Section key:', sectionKey);
    
  // Create a container for all sections
  const sectionsContainer = document.createElement('div');
  sectionsContainer.className = 'dynamic-sections-container bg-white';
  
  // Define the order of sections to show
  let sectionsToShow = [
    'header',           // Header section
    sectionKey,         // Condition-specific sections
    'reviews',          // Reviews section
    'founders-video',   // Founders video section
    'faqs',            // FAQs section
  ];

  if (quizData.sections[person][skinCondition]) {
    logger.info('Found unique sections to show:', quizData.sections[person][skinCondition]);
    sectionsToShow = quizData.sections[person][skinCondition];

    // replace "sections" with sectionKey
    sectionsToShow = sectionsToShow.map(section => section === "solution" ? sectionKey : section);
  }
  
  logger.info('Sections to show:', sectionsToShow);
  
  // Track which sections we've already added to prevent duplicates
  const addedSections = new Set();
  
  // Add sections in order
  sectionsToShow.forEach(sectionName => {
    // Skip if we've already added this section
    if (addedSections.has(sectionName)) {
      logger.debug('Skipping duplicate section:', sectionName);
      return;
    }
    
    // first check if section exists in dom, and move it
    const section = document.querySelector(`[data-show-for="${sectionName}"]`);
    
    // don't do if it's reviews section
    if (section && sectionName !== 'reviews') {
      sectionsContainer.insertAdjacentHTML('beforeend', section.outerHTML);
      addedSections.add(sectionName);
    } else if (preparedSections[sectionName]) {
      logger.debug('Adding prepared section:', sectionName);
      sectionsContainer.insertAdjacentHTML('beforeend', preparedSections[sectionName][0]);
      addedSections.add(sectionName);
    } else if (sectionName === sectionKey) {
      logger.debug('Adding section:', sectionName);
      // loop through all sections, and if the sectionKey is in the data-show-for attribute, add the section to the sectionsContainer
      let foundSolutions = false;
      Object.keys(preparedSections).forEach(key => {
        logger.debug('Checking key:', key);
        if (key.includes(sectionKey) && !addedSections.has(key)) {
          logger.debug('Adding section:', key);
          preparedSections[key].forEach(sectionHtml => {
            sectionsContainer.insertAdjacentHTML('beforeend', sectionHtml);
          });
          addedSections.add(key);
          foundSolutions = true;
        }
      });
      if (!foundSolutions) {
        showBasicRecommendations(sectionsContainer);
        // Fallback to the original method if no prepared sections for condition
        logger.debug('Using fallback for section:', sectionName);
        const relevantSections = document.querySelectorAll(`[data-show-for="${sectionKey}"]`);
        relevantSections.forEach(section => {
          const parent = section.closest('.shopify-section');
          if (parent) {
            parent.classList.remove('hidden');
          }
        });
      }
    }
  });

  // Add the container to the page
  const firstSection = document.querySelector('.shopify-section');
  if (firstSection) {
    firstSection.parentNode.insertBefore(sectionsContainer, firstSection);
  }

  // Dispatch event that solutions are shown
  const solutionsShownEvent = new CustomEvent('solutionsShown', {
    detail: {
      person,
      skinCondition,
      sectionsContainer
    }
  });
  document.dispatchEvent(solutionsShownEvent);
  
  logger.success('Section visibility updated');
}

// Fade out the dialog and then close it
function fadeOutDialog() {
  logger.info('Fading out dialog...');
  const quizDialog = document.getElementById('quiz-dialog');
  
  // Add the fade-out class
  quizDialog.classList.add('fade-out');
  
  // Close the dialog after the animation completes
  setTimeout(() => {
    quizDialog.close();
    // Reset opacity for next time
    quizDialog.classList.remove('fade-out');
    
    // Update all quiz trigger buttons
    document.querySelectorAll('[data-trigger-quiz]').forEach(button => {
      button.textContent = 'RETURN TO YOUR PERSONALISED SOLUTION';
      // Add click handler to scroll to top
      button.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
    
    logger.success('Dialog closed and buttons updated');
  }, 800);
}

// Start the quiz
function startQuiz() {
  if (!sectionsReady) {
    logger.info('Quiz attempted to start before sections were ready');
    return;
  }
  
  logger.info('Starting quiz...');
  // Generate questions
  generateQuestions();
  
  // Show the dialog
  const quizDialog = document.getElementById('quiz-dialog');
  quizDialog.showModal();
  logger.success('Quiz dialog shown');
}

function initializeWhatsInTheSet(container) {
  logger.info('Initializing What\'s in the Set');

  // Handle What's in the Set dropdown
  const whatsInSetButtons = container.querySelectorAll('[data-toggle-dropdown]');

  whatsInSetButtons.forEach(button => {
    const dropdownContent = button.nextElementSibling;

    if (dropdownContent) {
      button.addEventListener('click', function() {
        const svg = this.querySelector('svg');
        svg.classList.toggle('rotate-180');
        
        if (dropdownContent.classList.contains('max-h-0')) {
          dropdownContent.classList.remove('max-h-0');
          dropdownContent.classList.add('max-h-[1000px]');
        } else {
          dropdownContent.classList.remove('max-h-[1000px]');
          dropdownContent.classList.add('max-h-0');
        }
      });
    }
  });
}

// Function to initialize FAQs
function initializeFAQs(container = document) {
  const faqItems = container.querySelectorAll('.faq-item');
  logger.info('Initializing FAQs', { count: faqItems.length });
  
  faqItems.forEach(item => {
    const button = item.querySelector('.faq-button');
    const answer = item.querySelector('.faq-answer');
    const content = answer.querySelector('div');
    
    // Initialize height for animation
    let isOpen = false;
    let contentHeight = content.offsetHeight;
    
    // Update content height on window resize
    window.addEventListener('resize', () => {
      if (isOpen) {
        contentHeight = content.offsetHeight;
        answer.style.height = contentHeight + 'px';
      }
    });
    
    button.addEventListener('click', () => {
      // Update content height in case content changed
      contentHeight = content.offsetHeight;
      
      // Toggle state
      isOpen = !isOpen;
      
      // Update button state
      button.setAttribute('aria-expanded', isOpen);
      
      // Animate answer height
      answer.style.height = isOpen ? `${contentHeight}px` : '0';
      
      // Close other open FAQs
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          const otherButton = otherItem.querySelector('.faq-button');
          const otherAnswer = otherItem.querySelector('.faq-answer');
          
          otherButton.setAttribute('aria-expanded', 'false');
          otherAnswer.style.height = '0';
        }
      });
    });
  });
}

// Initialize event listeners and start loading sections
(function initQuiz() {
  // Only initialize if not already initialized
  if (window.quizInitialized) {
    logger.info('Quiz already initialized');
    return;
  }

  // Set initial background color from .lp1-base
  const baseElement = document.querySelector('.lp1-base-settings');
  if (baseElement) {
    logger.info('Base element found:', baseElement);
    const bgColor = baseElement.getAttribute('bg');
    if (bgColor) {
      logger.info('Setting initial background color:', bgColor);
      document.querySelector('.main-content').style.backgroundColor = bgColor;
    }
  }

  // Set up quiz buttons in a non-blocking way
  const setupButtons = () => {
    document.querySelectorAll('[data-trigger-quiz]').forEach(button => {
      button.addEventListener('click', startQuiz);
    });
  };

  // Start loading sections after a small delay to ensure ATF content loads first
  const startSectionLoading = () => {
    setTimeout(() => {
      prepareSections();
      logger.success('Section loading started');
    }, 100); // Small delay to ensure ATF content loads first
  };

  // Handle solutions after they're injected
  document.addEventListener('solutionsShown', (event) => {
    const { person, skinCondition, sectionsContainer } = event.detail;
    logger.info('Solutions shown, initializing handlers', { person, skinCondition });

    // Remove background color when sections are shown
    document.querySelector('.main-content').style.backgroundColor = '#FFFFFF';

    // Attach Add to Cart handlers
    attachAddToCartHandlers();

    initializeWhatsInTheSet(sectionsContainer);

    // Initialize FAQs in the injected sections
    initializeFAQs(sectionsContainer);
  });

  // Initialize in the correct order
  if (document.readyState === 'loading') {
    // If document is still loading, set up buttons and start loading sections
    document.addEventListener('DOMContentLoaded', () => {
      setupButtons();
      startSectionLoading();
      initializeWhatsInTheSet(document.querySelector('body'));
      // Initialize FAQs on initial page load
      initializeFAQs();
    });
  } else {
    // If document is already loaded, proceed immediately
    setupButtons();
    startSectionLoading();
    initializeWhatsInTheSet(document.querySelector('body'));
    // Initialize FAQs on initial page load
    initializeFAQs();
  }

  window.quizInitialized = true;
})();

// Function to handle Add to Cart button clicks
async function handleAddToCartClick() {
  const productId = this.getAttribute('atc-variant-id');
  const mock = false; // Set to true for testing
  const logger = createLogger(false, 'Cart', 'debug');
  
  try {
    if (!mock) {
      // First clear the cart
      const clearResponse = await fetch("/cart/clear.js", { method: "POST" });
      if (!clearResponse.ok) {
        throw new Error(`HTTP error! status: ${clearResponse.status}`);
      }
      logger.success("Cart cleared successfully");
    } else {
      logger.info("MOCK: Would clear cart");
    }

    // Then add the new product
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart/add';

    const idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = productId;
    form.appendChild(idInput);

    const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1';
    form.appendChild(quantityInput);

    // Add Person custom property
    const personPropertyInput = document.createElement('input');
    personPropertyInput.type = 'hidden';
    personPropertyInput.name = 'attributes[Quiz]';
    // Use the quiz questions to get the person and skin condition
    const person = quizData.questions[0].options.find(opt => opt.value === quizResults.person).shopify_answer;
    const skinCondition = quizData.questions[1].options.find(opt => opt.value === quizResults.skin_condition).shopify_answer;
    personPropertyInput.value = `${person} | ${skinCondition}`;
    form.appendChild(personPropertyInput);

    // Add checkout redirection
    const checkoutTypeInput = document.createElement('input');
    checkoutTypeInput.type = 'hidden';
    checkoutTypeInput.name = 'return_to';
    checkoutTypeInput.value = '/checkout/';
    form.appendChild(checkoutTypeInput);

    if (!mock) {
      document.body.appendChild(form);
      const formData = new FormData(form);
      logger.info("Submitting cart form", ...formData);
      form.submit();
    } else {
      logger.info("MOCK: Would submit form to:", form.action);
    }
  } catch (error) {
    logger.error('Error in cart operation:', error);
  }
}

// Function to attach Add to Cart handlers
function attachAddToCartHandlers() {
  const logger = createLogger(false, 'Cart', 'debug');
  logger.debug('Attaching Add to Cart handlers');
  
  // Remove any existing click handlers
  const existingButtons = document.querySelectorAll('[atc-variant-id]');
  existingButtons.forEach(button => {
    button.removeEventListener('click', handleAddToCartClick);
  });

  // Attach new click handlers
  const addToCartButtons = document.querySelectorAll('[atc-variant-id]');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', handleAddToCartClick);
  });
  logger.success('Add to Cart handlers attached');
}

// Initialize a section
function initializeSection(sectionType) {
  const logger = createLogger(false, sectionType, 'debug');
  logger.info(`Initializing ${sectionType} section`);
  
  // Handle What's in the Set dropdown
  const whatsInSetButton = document.querySelector('[data-toggle-dropdown]');
  const dropdownContent = document.querySelector('.dropdown-content');

  if (whatsInSetButton && dropdownContent) {
    whatsInSetButton.addEventListener('click', function() {
      const svg = this.querySelector('svg');
      svg.classList.toggle('rotate-180');
      
      if (dropdownContent.classList.contains('max-h-0')) {
        dropdownContent.classList.remove('max-h-0');
        dropdownContent.classList.add('max-h-[500px]');
      } else {
        dropdownContent.classList.remove('max-h-[500px]');
        dropdownContent.classList.add('max-h-0');
      }
    });
  }

  // Attach Add to Cart handlers
  attachAddToCartHandlers();
  logger.success(`${sectionType} section initialized`);
}

// Set up event listeners for quiz
function setupEventListeners() {
    logger.info('Setting up quiz event listeners');
    
    // Handle quiz trigger buttons
    document.querySelectorAll('[data-trigger-quiz]').forEach(button => {
        button.addEventListener('click', () => {
            logger.info('Quiz trigger button clicked');
            startQuiz();
        });
    });
    
    // Handle quiz navigation
    document.querySelectorAll('[data-quiz-next]').forEach(button => {
        button.addEventListener('click', () => {
            logger.info('Next question button clicked');
            nextQuestion();
        });
    });
    
    document.querySelectorAll('[data-quiz-prev]').forEach(button => {
        button.addEventListener('click', () => {
            logger.info('Previous question button clicked');
            prevQuestion();
        });
    });
    
    // Handle quiz option selection
    document.querySelectorAll('[data-quiz-option]').forEach(option => {
        option.addEventListener('click', () => {
            const questionId = option.closest('[data-quiz-question]').getAttribute('data-quiz-question');
            const optionValue = option.getAttribute('data-quiz-option');
            logger.info('Quiz option selected:', { questionId, optionValue });
            selectOption(questionId, optionValue);
        });
    });
    
    // Handle quiz restart
    document.querySelectorAll('[data-quiz-restart]').forEach(button => {
        button.addEventListener('click', () => {
            logger.info('Quiz restart button clicked');
            restartQuiz();
        });
    });
}
